import { render, staticRenderFns } from "./v-right-card4.vue?vue&type=template&id=c9bc7bda&scoped=true"
import script from "./v-right-card4.vue?vue&type=script&lang=js"
export * from "./v-right-card4.vue?vue&type=script&lang=js"
import style0 from "./v-right-card4.vue?vue&type=style&index=0&id=c9bc7bda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bc7bda",
  null
  
)

export default component.exports